export default __webpack_public_path__ + "static/media/sketching.058ceb1a.jpg";